var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"txtButtonAddBasket2",attrs:{"href":_vm.createCookie('quickcookie','true',7),"title":"Checkout"},on:{"click":_vm.buyItem}},[_vm._v("  BUY NOW")])}
var staticRenderFns = []

export { render, staticRenderFns }